export const iconFontAwesomeMapsSpoon = (
	<i className="fa-solid fa-spoon"></i>
);
